import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=684be52c&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684be52c",
  null
  
)

/* custom blocks */
import block0 from "./UserProfile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684be52c')) {
      api.createRecord('684be52c', component.options)
    } else {
      api.reload('684be52c', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=684be52c&scoped=true&", function () {
      api.rerender('684be52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UserProfile.vue"
export default component.exports